import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 8px;
  width: 500px;
  max-height: 80%;
  overflow-y: auto;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
`;

export const ModalHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  padding: 16px 20px 16px 24px;
  font-family: "Open Sans", sans-serif;
  color: #697979;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    color: #697979;
  }
`;

export const UploadSection = styled.div`
  border: 2px dashed #d3d3d3;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  text-align: center;
  min-height: 160px;
  max-height: 200px;
  color: #7a7a7a;
  font-size: 14px;
  font-family: "Open Sans, sans-serif";
  margin-bottom: 8px;
  cursor: pointer;
  position: relative;

  input {
    display: none;
  }

  &:hover {
    background-color: #f9f9f9;
  }
`;

export const EmptyUploadMessage = styled.div`
  min-height: 34px;
  font-family: "Open Sans", sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 16px;
  gap: 10px;
  align-items: center;
  align-content: center;
  justify-content: center;
  min-height: 160px;
  max-height: 200px;
  overflow-y: auto;
  border-radius: 4px;
`;

export const FileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 8px;
  background-color: #fff;
  border: 1px solid #d3d3d3;
  border-radius: 4px;
  font-size: 12px;

  span {
    margin-left: 4px;
    color: #707070;
    font-size: 12px;
    font-family: "Open Sans", sans-serif;
  }

  button {
    margin-left: 10px;
    border: none;
    background: none;
    cursor: pointer;
    color: #707070;
    font-size: 22px;
  }
`;

export const FileSupportNote = styled.small`
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: #707070;
`;

export const ErrorMessage = styled.small`
  width: 100%;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: #E80000;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Label = styled.label`
  width: 100%;
  font-family: "Open Sans", sans-serif;
  color: #707070;
  font-size: 16px;
  margin-top: 20px;
`;

export const ColorInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  width: 100%;
  align-items: center;
  position: relative;
  padding-right: 4px;

  input[type="text"] {
    flex-grow: 1;
    border: none;
    outline: none;
    height: 30px;
    color: #707070;
    font-size: 14px;
    margin: 8px 10px;
  }

  input[type="color"] {
    display: ${({ show }) => (show ? "block" : "none")};
    position: absolute;
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    border: none;
    margin: 0;
    padding: 0;
    z-index: 10;
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
  }
`;

export const IconSelection = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 8px;

  label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    input {
      appearance: none;
      margin: 0;
      width: 12px;
      height: 12px;
      border: 1.5px solid #007842;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      &:checked + .icon svg {
        fill: #007842;
        stroke: #007842;
      }

        &:checked {
        background-color: #fff; /* Keep the outer circle white */
        border: 1.5px solid #00804E; /* Blue border when selected */

        /* Add the inner green circle */
        &::after {
          content: "";
          position: absolute;
          width: 8px; /* Inner circle size */
          height: 8px;
          background-color: #007842; /* Inner green circle color */
          border-radius: 50%;
        }
    }

    .icon {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        fill: #707070;
        stroke: #707070;
        transition: fill 0.3s, stroke 0.3s;
      }
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 24px;
  gap: 10px;

  button {
    padding: 8px 16px;
    border: none;
    border-radius: 40px;
    font-size: 14px;
    cursor: pointer;
    font-family: "Open Sans", sans-serif;
  }

  .cancel {
    background: #fff;
    border: 1px solid #006f35;
    color: #333;
  }

  .confirm {
    background: #006f35;
    color: #fff;
  }
`;

export const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const Input = styled.input`
  text-align: left;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #707070;
  placeholder {
    text-align: left;
    font: normal normal normal 16px/22px Open Sans;
    letter-spacing: 0px;
    color: #707070;
    opacity: 0.5;
  }
`;